import React from 'react'

export default function Countdown() {
  return (
    <div className="countdown">
      <div className="countdown-circle">
        <span className="countdown-span">3</span>
        <span className="countdown-span">2</span>
        <span className="countdown-span">1</span>
        <span className="countdown-span">GO!</span>
      </div>
    </div>
  )
}
